const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const ageGateParam = urlParams.get('cbgAge');
const noCookiesParam = urlParams.get('cbgNoCookies');
const manageCookiesParam: boolean = urlParams.get('cbgManage') === 'true';

import { parseFooterTemplate } from './parse-footer-template';

const getCbgCompScript = () => document.getElementById('cbgCompPack');

const getScriptInfo = () => {
  const cbgCompScript = getCbgCompScript();
  const scriptSrc = cbgCompScript?.getAttribute('src');
  const GTMId = cbgCompScript?.getAttribute('data-gtm-id');
  const GTMId4 = cbgCompScript?.getAttribute('data-gtm-id-ga4');
  const langAttr = cbgCompScript?.getAttribute('data-culture');
  const disableFocusTrap =
    cbgCompScript?.getAttribute('data-disable-focus-trap') === 'true';
  const env = cbgCompScript?.getAttribute('data-env');
  const policyPage = cbgCompScript?.getAttribute('data-policy-page');
  const cookiesPage = cbgCompScript?.getAttribute('data-cookies-page');
  const showAgeGateway: boolean =
    cbgCompScript?.getAttribute('data-verify-age') === 'true';
  const checkCookies: boolean =
    cbgCompScript?.getAttribute('data-set-cookies') !== 'false';
  const noTracking = cbgCompScript?.getAttribute('data-no-tracking') === 'true';
  const isShopify = cbgCompScript?.getAttribute('data-shopify') === 'true';

  return {
    GTMId,
    GTMId4,
    langAttr,
    scriptSrc,
    showAgeGateway,
    checkCookies,
    env,
    policyPage,
    cookiesPage,
    disableFocusTrap,
    noTracking,
    isShopify
  };
};

const getProjectInfo = () => {
  const cbgCompScript = getCbgCompScript();
  const projectId = cbgCompScript?.getAttribute('data-prj-id');
  const prjMarket = cbgCompScript?.getAttribute('data-market');
  const entityNameAttr = cbgCompScript?.getAttribute('data-entity-name');
  const formalEntityAttr = cbgCompScript?.getAttribute('data-formal-entity');

  return { projectId, prjMarket, entityNameAttr, formalEntityAttr };
};

const getFooterTemplate = () => {
  const cbgCompScript = getCbgCompScript();
  const selectorAttr = cbgCompScript?.getAttribute('data-footer-template');

  if (!selectorAttr) return null;

  return parseFooterTemplate(selectorAttr);
};

export {
  getScriptInfo,
  getProjectInfo,
  getFooterTemplate,
  ageGateParam,
  noCookiesParam,
  manageCookiesParam
};
